import { useState, createContext } from 'react'

const SolusBioContext = createContext()

const SolusBioProvider = ({ children }) => {
  const [counterBio, setCounterBio] = useState(0)

  const handleResetCounter = () => {
    setCounterBio(false)
  }

  const value = {
    counterBio,
    setCounterBio,
    handleResetCounter
  }

  return (
    <SolusBioContext.Provider value={value}>
      {children}
    </SolusBioContext.Provider>
  )
}

export { SolusBioContext, SolusBioProvider }
